import { setupWorker } from 'msw/browser';
import { api } from './handlers';

// @ts-expect-error - msw types are not compatible
export const worker = setupWorker(...api);
